import React, { FC, PureComponent } from 'react';
import { Routes, Route } from 'react-router-dom';

import { Page } from 'helpers/hasAccess';
import { LocalizedTitle } from 'shared/components/other';
import { PrivateRoute } from 'shared/components/domain/PrivateRoute';
import { Footer } from 'shared/components/layout/Footer';
import Sidebar from './components/Sidebar';
import { EditAdvertiser as AdvertiserSettings } from './EditAdvertiser';
import { EditBrands as BrandSettings } from './EditBrands';
import { Appearance } from './Appearance';
import { Templates } from './Templates';
import { PowerBiDefaultSettings, PowerBiAdvertiserSettings } from './PowerBiSettings';

import classes from './Administration.module.scss';

class Administration extends PureComponent {
  render() {
    return (
      <div className={classes.Layout}>
        <LocalizedTitle id="header.settings.administration" />
        <Sidebar />
        <section className={classes.Administration}>
          <div className={classes.Content}>
            <AdministrationRoutes />
            <Footer />
          </div>
        </section>
      </div>
    );
  }
}

const AdministrationRoutes: FC = () => (
  <Routes>
    <Route
      path="advertiser"
      element={
        <PrivateRoute checkableFeature={adminTabToAccessFeatureMap.get('advertiser')}>
          <AdvertiserSettings />
        </PrivateRoute>
      }
    />
    <Route
      path="brands/:id?"
      element={
        <PrivateRoute checkableFeature={adminTabToAccessFeatureMap.get('brands')}>
          <BrandSettings />
        </PrivateRoute>
      }
    />
    <Route
      path="appearance"
      element={
        <PrivateRoute checkableFeature={adminTabToAccessFeatureMap.get('appearance')}>
          <Appearance />
        </PrivateRoute>
      }
    />
    <Route
      path="templates"
      element={
        <PrivateRoute checkableFeature={adminTabToAccessFeatureMap.get('templates')}>
          <Templates />
        </PrivateRoute>
      }
    />
    <Route
      path="powerbi-default-settings"
      element={
        <PrivateRoute checkableFeature={adminTabToAccessFeatureMap.get('powerbi-default-settings')}>
          <PowerBiDefaultSettings />
        </PrivateRoute>
      }
    />
    <Route
      path="powerbi-advertiser-settings"
      element={
        <PrivateRoute checkableFeature={adminTabToAccessFeatureMap.get('powerbi-advertiser-settings')}>
          <PowerBiAdvertiserSettings />
        </PrivateRoute>
      }
    />
  </Routes>
);

export const adminTabToAccessFeatureMap = new Map<string, Page>([
  ['advertiser', 'administration'],
  ['brands', 'administration'],
  ['appearance', 'administration'],
  ['templates', 'templates'],
  ['powerbi-default-settings', 'powerbiDefaultSettings'],
  ['powerbi-advertiser-settings', 'administration'],
]);

export { Administration };
